import _, { reduce } from 'lodash';

export const statusColors = {
    gray: 'rgb(170, 170, 170)',
    green: 'rgb(112, 195, 119)',
    yellow: 'rgb(255, 220, 117)',
    orange: 'rgb(250, 173, 78)',
    red: 'rgb(235, 120, 97)',
};

export function getStatusColor(color, opacity = 1.0) {
    switch (color) {
        case 'blank':
            return '#F8F8F8';
        case 'green':
            return `rgb(112, 195, 119, ${opacity})`;
        case 'yellow':
            return `rgb(255, 220, 117, ${opacity})`;
        case 'orange':
            return `rgb(250, 173, 78, ${opacity})`;
        case 'red':
            return `rgb(235, 120, 97, ${opacity})`;
        default:
            return `rgb(170, 170, 170, ${opacity})`;
    }
}

export function getStatusName(statusValue) {
    const status = orderedStatuses.find((item) => item.value === statusValue);
    return status?.name;
}

export function getWorstStatus(statuses) {
    if (!statuses || !_.isArray(statuses)) {
        return gray.value;
    }

    if (_.includes(statuses, red.value)) return red.value;
    if (_.includes(statuses, orange.value)) return orange.value;
    if (_.includes(statuses, yellow.value)) return yellow.value;
    if (_.includes(statuses, green.value)) return green.value;
    return gray.value;
}

export function getWorstStatusColor(status) {
    if (!status || !_.isObject(status)) {
        return gray.value;
    }

    if (status[red.value] > 0) {
        return red.value;
    }

    if (status[orange.value] > 0) {
        return orange.value;
    }

    if (status[yellow.value] > 0) {
        return yellow.value;
    }

    if (status[green.value] > 0) {
        return green.value;
    }

    return gray.value;
}

export const green = {
    name: 'Normal',
    color: 'green',
    value: 'green',
};

export const gray = {
    name: 'No Data',
    color: 'gray',
    value: 'gray',
};

export const yellow = {
    name: 'Degraded',
    color: 'yellow',
    value: 'yellow',
};

export const orange = {
    name: 'Excessive',
    color: 'orange',
    value: 'orange',
};

export const red = {
    name: 'Critical',
    color: 'red',
    value: 'red',
};

export const orderedStatuses = [gray, green, yellow, orange, red];
export const statuses = reduce(
    orderedStatuses,
    (statusRes, status) => {
        statusRes[status.value] = status;
        return statusRes;
    },
    {}
);
